import {combineReducers} from "redux";
import {routerReducer} from "react-router-redux";
import Settings from "appRedux/reducers/Settings";
import Auth from "appRedux/reducers/Auth";


const reducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/flexile/appRedux/reducers/index.js